import { render } from "./DrillView.vue?vue&type=template&id=ef673c2a&scoped=true"
import script from "./DrillView.vue?vue&type=script&lang=js"
export * from "./DrillView.vue?vue&type=script&lang=js"

import "./DrillView.vue?vue&type=style&index=0&id=ef673c2a&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef673c2a"]])

export default __exports__